import { NpoPlayerUIVariants } from '../../types/interfaces';
export const handleVerticalVideoControls = (playerContext, variant) => {
    const MAX_DURATION_IN_SECONDS = 30;
    const isShortVideo = playerContext.player.getDuration() <= MAX_DURATION_IN_SECONDS;
    const hasVerticalUI = variant === NpoPlayerUIVariants.VERTICAL;
    const isVerticalShortVideo = hasVerticalUI && isShortVideo;
    playerContext.player.toggleClassOnNpoPlayerElement('vertical-short-video', isVerticalShortVideo);
};
